import { render, staticRenderFns } from "./LoyaltyAccounts.vue?vue&type=template&id=89b91cd2&scoped=true&lang=pug&"
import script from "./LoyaltyAccounts.vue?vue&type=script&lang=js&"
export * from "./LoyaltyAccounts.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyAccounts.vue?vue&type=style&index=0&id=89b91cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b91cd2",
  null
  
)

export default component.exports